import { VImg } from 'vuetify/lib/components/VImg';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{attrs:{"href":"https://www.comfortmoney.cz/pujcky/","target":"_blank"}},[_c(VImg,{attrs:{"src":require('@/assets/logo.png'),"alt":_vm.$t('logo.alt'),"height":_vm.$vuetify.breakpoint.xsOnly ? '4.32rem' : '5.19rem',"max-width":"120px","contain":""}}),_c('span',{staticClass:"d-sr-only"},[_vm._v(" "+_vm._s(_vm.$t('title'))+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }